const centorMagnetColors = [
  { id: 1, type: "magnetCatchColor", label: "Stainless Steel" },
  { id: 2, type: "magnetCatchColor", label: "Black" },
];

const magnets = { id: 2, type: "magnetCatch", label: "Add Centor Magnet Catch" }

export { centorMagnetColors, magnets };
